import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { SpinnerService, ContextStateService, LayoutService } from '../../shared/services';
import { filter, fromEvent, Observable } from 'rxjs';
import { map, startWith, distinctUntilChanged } from 'rxjs/operators';
import { ScreenService } from 'grow-angular/services';
import { log } from 'src/debug';
import { licenseKey } from '../../../devextreme-license';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AdminNavigationStateService } from '../../pages-frontend/services/admin-navigation-state.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
 })
export class PageContentComponent implements OnInit, OnDestroy {

  readonly #debug: boolean = false;

  isMobile$: Observable<boolean> = this.screenService.isMobile$;

  // Reaktive Phone-Erkennung (768px = 'phone'-Breakpoint, konsistent mit dem CSS).
  // Bewusst NICHT ScreenService.isMobile$, das erst bei 960px (Phone + Tablet) schaltet.
  isPhone$: Observable<boolean> = fromEvent(window, 'resize').pipe(
    map(() => window.innerWidth <= 768),
    startWith(window.innerWidth <= 768),
    distinctUntilChanged()
  );
  //context = this.contextState.currentContext;
  isDrawerOpen: boolean = false; //KS, 20260518 true;
  selectedOpenMode: string = 'shrink';
  selectedPosition: string = 'left';
  selectedRevealMode: string = 'slide';

  // KS, 20260516
  private contextStateService = inject(ContextStateService);
  private destroyRef = inject(DestroyRef);
  context = this.contextStateService.currentContext;

  // KS, 20260517
  private adminNavigationStateService = inject(AdminNavigationStateService);
  isDrawerOpen$: Observable<boolean> = this.adminNavigationStateService.adminNavigationState$;
  private destroy$ = new Subject<void>();

  constructor(
    private screenService: ScreenService,
    //protected contextState: ContextStateService,
    public layout: LayoutService,
    public spinner: SpinnerService
  ) {}

  ngOnInit() {
    if(this.#debug) console.log('PageContentComponent ngOnInit');
    //if(this.#debug) console.log('devExtremeLicenseKey', licenseKey);

    // KS, 20260516
    this.contextStateService.getContext().pipe(
      filter(context => !!context),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(context => {
      if(this.#debug) console.log('[PageContentComponent] Context gesetzt:', context);
      // KS, 20260518 - kein automatischen öffnen mehr
      //this.onContextChanged(context);
    });

    this.isDrawerOpen = this.adminNavigationStateService.getState();

    this.isDrawerOpen$.pipe(takeUntil(this.destroy$)).subscribe((state) => {
      this.isDrawerOpen = state;
    });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // KS, 20260516
  private onContextChanged(context: any): void {
    this.isDrawerOpen = context.menuItems.primary.length > 0;
    if(this.#debug) console.log('[PageContentComponent] this.isDrawerOpen:', this.isDrawerOpen);
  }

  toggleNavigation(event: any) {
    log(`toggleNavigation %o`, event);
    this.isDrawerOpen = event;
  }
}
